import React, { useEffect } from 'react';
import { DayButton } from 'react-day-picker';
import ReactTooltip from 'react-tooltip';
import PropTypes from 'prop-types';

export const UNSYNCED_TOOLTIP_ID = 'schedule-calendar-unsynced-tooltip';

const ScheduleCalendarDayButton = ({ day, modifiers, ...props }) => {
  // Closing the dropdown or changing month unmounts the hovered cell without a mouseleave, and
  // react-tooltip leaves the bubble on screen forever unless it is dismissed here.
  useEffect(() => () => ReactTooltip.hide(), []);

  if (modifiers.disabled) {
    return (
      <span className="date-picker-day__tooltip-anchor" data-tip data-for={UNSYNCED_TOOLTIP_ID}>
        <DayButton day={day} modifiers={modifiers} {...props} />
      </span>
    );
  }

  return <DayButton day={day} modifiers={modifiers} {...props} />;
};

ScheduleCalendarDayButton.propTypes = {
  day: PropTypes.shape({}).isRequired,
  modifiers: PropTypes.shape({
    disabled: PropTypes.bool,
  }).isRequired,
};

export default ScheduleCalendarDayButton;
